import type { RouteRecordRaw } from "vue-router";

import BaseLayout from "@/layout/app/BaseLayout.vue";

import BaseRoutes from "../enums/routes/BaseRoutes";

export function baseRoutes(): RouteRecordRaw[] {
    return [
        {
            path: "/signin",
            name: BaseRoutes.SIGN_IN,
            component: () => import("../views/SignInView.vue"),
        },
        {
            path: "/apps/signin",
            component: BaseLayout,
            children: [
                {
                    path: "/apps/signin",
                    name: BaseRoutes.APP_SIGN_IN,
                    component: () => import("../views/apps/SignInView.vue"),
                },
                {
                    path: "/apps/code/check",
                    name: BaseRoutes.CODE_CHECK,
                    component: () => import("../views/apps/CodeCheckView.vue"),
                },
            ],
        },
        {
            path: "/apps",
            name: BaseRoutes.APPS,
            component: () => import("../views/apps/AppRouterView.vue"),
            // TODO validovat jestli byl proveden settings jinak redirect
            // beforeEnter: (to, from) => {
            //     if (false) {
            //         return { name: BaseRoutes.HOME };
            //     }
            //     return true;
            // },
        },
    ];
}
